module.exports = __webpack_public_path__ + "static/media/ios-contract.a838f782.svg";